export default __webpack_public_path__ + "static/media/plantseparator.a04b087b.svg";